import React, {useState, useEffect} from "react";
import {Link} from "react-router-dom";
import {Card, CardBody, Col, Container, Input, Row} from "reactstrap";
import Skeleton from "react-loading-skeleton";
import ApiService from "../util/ApiService";
import "bootstrap/dist/css/bootstrap.min.css";
import "font-awesome/css/font-awesome.min.css";
import DutyDetailModal from "./calender/dutyDetailModal";
import CustomPagination from "../util/CustomPagination";
import "./assets/css/DudyListDesboard.css";
import {FaCheckCircle, FaClock, FaTimesCircle} from "react-icons/fa";
import PlantaoModal from "./calender/plantaoModal";
import PlantaoRepostModal from "./calender/plantaoRepostModal";
import dayjs from "dayjs";
const DudyListDesboard = ({duties, currentDate, detailDuty}) => {
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 6,
        total: 0,
        lastPage: 0,
    });
    const [loading, setLoading] = useState(true);
    const [selectedDuty, setSelectedDuty] = useState(null);
    const [duty, setDuty] = useState([]);

    const [modalVisible, setModalVisible] = useState(false);
    const [showDutyModal, setShowDutyModal] = useState(false);
    const [showPlantaoRepostModal, setShowPlantaoRepostModal] = useState(false);

    useEffect(() => {
        setLoading(false);


        const filteredDuties = duties.filter((duty) => {
            const dutyDate = new Date(duty.date_time).toISOString().split("T")[0];
            return dutyDate === currentDate;
        });

        setPagination((prev) => ({
            ...prev,
            total: filteredDuties.length,
            lastPage: Math.ceil(filteredDuties.length / prev.pageSize),
        }));
    }, [currentDate, duties]);

    const handlePageChange = (page) => {
        setPagination((prev) => ({
            ...prev,
            current: page,
        }));
    };

    const handleDutyClick = (duty) => {
        setSelectedDuty(duty);
        setModalVisible(true);
    };

    const handleModalClose = () => {
        setModalVisible(false);
        setSelectedDuty(null);
    };

    const handlePlantaoModalClose = () => {
        setShowDutyModal(false);
    };

    const handlePlantaoRepostModalClose = () => {
        setShowPlantaoRepostModal(false);
    };

    const getStatusIcon = (status) => {
        switch (status) {
            case "pending":
                return <FaClock color="#ffc107"/>;
            case "accepted":
                return <FaCheckCircle color="#28a745"/>;
            case "refused":
                return <FaTimesCircle color="#dc3545"/>;
            default:
                return null;
        }
    };

    const paginatedDuties = duties
        .filter((duty) => {
            const dutyDate = new Date(duty.date_time).toISOString().split("T")[0];
            return dutyDate === currentDate;
        })
        .slice(
            (pagination.current - 1) * pagination.pageSize,
            pagination.current * pagination.pageSize
        );

    return (
        <div className="col-md-4 col-12 col-lg-4 ">
            <div className="col-12">


                <div style={{height: '60px'}}
                     className="bg-light px-3 py-2 rounded shadow-sm d-flex justify-content-between align-items-center">
                    <h5 className="mb-0 fw-bold text-dark">Plantões</h5>
                    <span className="text-muted" style={{fontSize: "15px"}}>
                       {dayjs(currentDate).format("DD/MM/YYYY")}
                      </span>
                </div>
                {loading ? (
                    <div className="row">
                        <Skeleton count={3}/>
                    </div>
                ) : (
                    <Row className="gy-0 mb-0" id="candidate-list">


                    {paginatedDuties.length > 0 ? (
                            paginatedDuties.map((duty, index) => (

                                <div  key={duty.id} className="p-2 shadow-sm card-hover duty-card-mini mt-1 ">
                                            <div className="m-2">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="text-truncate w-100" title={duty.hospital.name}>
                                                    <a
                                                        target="_blank"
                                                        href={`/admin/location-detail/${duty.hospital.url_page}`}
                                                        className="text-decoration-none text-dark fw-semibold small"
                                                        style={{
                                                            whiteSpace: 'nowrap',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            display: 'inline-block',
                                                            maxWidth: '100%',
                                                            fontSize: '13px',
                                                        }}
                                                    >
                                                        {duty.hospital.name}
                                                    </a>
                                                </div>
                                            </div>

                                            <div className="row col-12">
                                                <div className="col-8 text-muted mt-1" style={{fontSize: "11px"}}>
                                                    <i className="fa fa-calendar text-info me-1"></i>
                                                    {dayjs(duty.date_time).format("DD/MM HH:mm")} →
                                                    {dayjs(duty.date_time_end).format("DD/MM HH:mm")}
                                                </div>

                                                <div className="col-4 text-success mt-1" style={{fontSize: "12px"}}>
                                                    <i className="fa fa-money me-1"></i>
                                                    R$ {duty.value}
                                                </div>
                                            </div>

                                            <div className="mt-2">
                                                <button type="button"
                                                    className="btn btn-sm btn-outline-success py-1"
                                                    style={{fontSize: "11px"}}
                                                    onClick={() => handleDutyClick(duty)}
                                                >
                                                    <i className="fa fa-info-circle me-1"></i> Detalhes
                                                </button>
                                            </div>
                                    </div></div>


                            ))
                        ) : (

                            <div className="mt-0 alert alert-primary" role="alert">Nenhuma plantão encontrado
                            </div>

                        )}


                    </Row>
                )}
                <CustomPagination
                    pagination={pagination}
                    onChange={handlePageChange}
                />


                {selectedDuty && (
                    <DutyDetailModal
                        show={modalVisible}
                        handleClose={handleModalClose}
                        eventDetails={selectedDuty}
                        onRepost={(event) => {
                            setSelectedDuty(false);
                            setDuty(event);
                            setShowPlantaoRepostModal(true);
                        }}
                        onEdit={(event) => {
                            setSelectedDuty(false);
                            setDuty(event);
                            setShowDutyModal(true);
                        }}
                    />
                )}

                {showDutyModal && (
                    <PlantaoModal
                        show={showDutyModal}
                        handleClose={handlePlantaoModalClose}
                        duty={duty}
                    />
                )}

                {showPlantaoRepostModal && (
                    <PlantaoRepostModal
                        show={showPlantaoRepostModal}
                        handleClose={handlePlantaoRepostModalClose}
                        duty={duty}
                    />
                )}
            </div>
        </div>
    );
};

export default DudyListDesboard;
